import { render, staticRenderFns } from "./ContainingLists.vue?vue&type=template&id=52a3b657&scoped=true&"
import script from "./ContainingLists.vue?vue&type=script&lang=js&"
export * from "./ContainingLists.vue?vue&type=script&lang=js&"
import style0 from "./ContainingLists.vue?vue&type=style&index=0&id=52a3b657&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3b657",
  null
  
)

export default component.exports